export const parsePercentsFromNumeric = (source: number) =>
  `${(source * 100).toFixed(2)}%`;

export const removeYearFromDateString = (date: string) => {
  const destructedDate = date.split("/");

  return `${destructedDate[0]}.${destructedDate[1]}`;
};
